import { Link, usePage } from '@inertiajs/react'
import Layout from '../Layout'

interface User {
  id: number
  email_address: string
  role: string
  created_at: string
}

interface Account {
  id: number
  name: string
  slug: string
}

interface Props {
  users: User[]
  account: Account
  can_delete: boolean
  permissions?: {
    can_manage_users: boolean
  }
}

const roleLabels: Record<string, string> = {
  super_admin: 'Super Admin',
  admin: 'Administrador',
  supervisor: 'Supervisor',
  facturador: 'Facturador',
}

const roleColors: Record<string, string> = {
  super_admin: 'bg-purple-100 text-purple-800',
  admin: 'bg-blue-100 text-blue-800',
  supervisor: 'bg-green-100 text-green-800',
  facturador: 'bg-yellow-100 text-yellow-800',
}

export default function UsersIndex({ users, account, can_delete, permissions }: Props) {

  return (
    <Layout account={account} permissions={permissions}>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-[#202020]">Usuarios</h1>
        <Link
          href={`/${account.slug}/users/new`}
          className="bg-[#55ACEE] text-white px-4 py-2 rounded hover:bg-[#4a9ad6] transition-colors"
        >
          Nuevo Usuario
        </Link>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Rol
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Creado
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {users.map((user) => (
              <tr key={user.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {user.email_address}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${roleColors[user.role] || 'bg-gray-100 text-gray-800'}`}>
                    {roleLabels[user.role] || user.role}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(user.created_at).toLocaleDateString('es-ES')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <Link
                    href={`/${account.slug}/users/${user.id}/edit`}
                    className="text-[#55ACEE] hover:text-[#4a9ad6] mr-4"
                  >
                    Editar
                  </Link>
                  {can_delete && (
                    <Link
                      href={`/${account.slug}/users/${user.id}`}
                      method="delete"
                      as="button"
                      onClick={(e) => {
                        if (!confirm('¿Estás seguro de eliminar este usuario?')) {
                          e.preventDefault()
                        }
                      }}
                      className="text-red-600 hover:text-red-900"
                    >
                      Eliminar
                    </Link>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No hay usuarios registrados
          </div>
        )}
      </div>
    </Layout>
  )
}
